module.exports = __webpack_public_path__ + "static/media/idscan-background.25540729.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/images/idscan-background.png
// module id = 1814
// module chunks = 0